<template>
    <main class="container_pc">
        <h1 class="hdg1">お手続きできません</h1>
        <h2 class="hdg2">予期せぬエラーが発生しました。</h2>

        <div class="center">
            <img src="../image/error.svg" class="img_width">
        </div>

        <p class="Error_message">申し訳ございませんが、再度お見積り・プラン設計からお手続きいただくようお願いいたします。</p>

        <div class="container_phone footer_align">
            <div class="center">
                <span class="span_font1">日本生命お客様サポートオフィス<br>
                    <a class="a_phone" href="tel:0120-996-832">0120-996-832</a>
                </span>

                <span class="span_font2">（通話料無料）<br><span class="margin_right">月～金曜日</span>9:00～18:00<br>（祝日、12/31～1/3を除く）<br><br></span>
                <span class="span_bottom">Copyright (C) 2026 日本生命保険相互会社</span>
            </div>
        </div>
    </main>
</template>

<style scoped>
    .hdg1 {
        font-size: 2.0rem;
        font-weight: bold;
        line-height: 1.3;
        margin: 10px -10px;
        padding: 5px 0 4px 10px;
        border-bottom: 4px solid #f00;
    }

    .hdg2 {
        font-size: 2.0rem;
        font-weight: bold;
        line-height: 1.3;
        width: 100%;
        margin: 20px 0 25px;
    }

    .Error_message {
        font-size: 14px;
        margin-top: 25px;
    }

    .img_width {
        width: 100px;
    }
</style>

<script>
export default {
    data: function() {
        return {
        }
    },
}
</script>